"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuBanner = MenuBanner;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_1 = require("../styles");
const useStyles = (0, styles_1.createUseThemeStyles)((theme) => ({
    banner: {
        "display": "flex",
        "alignItems": "center",
        "gap": "0.6rem",
        "width": "100%",
        "padding": "0.7rem 1rem",
        "border": "none",
        "borderRadius": "0.6rem",
        "background": theme.palette.surface,
        "color": theme.palette.light.neutral,
        "fontFamily": theme.typography.primary,
        "fontSize": "1.1rem",
        "cursor": "pointer",
        "textAlign": "left",
        "transition": "filter 150ms ease",
        "&:hover": {
            filter: "brightness(1.1)",
        },
    },
    icon: {
        display: "flex",
        alignItems: "center",
        flex: "none",
        color: theme.palette.secondary.light,
    },
    label: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    suffix: {
        color: theme.palette.muted,
        whiteSpace: "nowrap",
    },
    chevron: {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
        color: theme.palette.muted,
        flex: "none",
    },
}));
function MenuBanner({ icon, label, suffix, chevron, onClick, className, }) {
    const classes = useStyles();
    return (React.createElement("button", { type: "button", className: (0, classnames_1.default)(classes.banner, className), onClick: onClick },
        icon && React.createElement("span", { className: classes.icon }, icon),
        React.createElement("span", { className: classes.label }, label),
        suffix && React.createElement("span", { className: classes.suffix }, suffix),
        chevron && React.createElement("span", { className: classes.chevron }, chevron)));
}
